import script from "./MaxioSubscriptionList.vue?vue&type=script&setup=true&lang=js"
export * from "./MaxioSubscriptionList.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__